/* eslint-disable */
import React, { useState, useEffect } from "react";
import Products from "./Products";
import AddProduct from "./AddProduct";
import { getProductsByUser } from "../../actions/productActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { Checkbox } from "@material-ui/core";
const ProductList = () => {
  const history = useHistory();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { products } = useSelector((state) => state.product);
  const isLoading = useSelector((state) => state.product.isLoading);
  const [archived, setaArchived] = useState(false);

  useEffect(() => {
    dispatch(
      getProductsByUser({
        search: user?.result?._id || user.result.googleId,
        archived,
      })
    );
  }, [location, dispatch, archived]);

  const handleSelectArchived = (event) => {
    if (event.target.checked) {
      setaArchived(true);
    } else {
      setaArchived(false);
    }
  };
  if (!user) {
    history.push("/login");
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (products?.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "start",

            flexDirection: "column",
            marginLeft: "-80%",
          }}
        >
          <label>Archived</label>
          <Checkbox
            checked={archived}
            onChange={(event) => handleSelectArchived(event)}
          />
        </div>
        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No products yet. Click the plus icon to add customer
        </p>
      </div>
    );
  }

  return (
    <div>
      <AddProduct
        open={open}
        setOpen={setOpen}
        currentId={currentId}
        setCurrentId={setCurrentId}
      />
      <div
        style={{
          display: "flex",
          alignItems: "start",

          flexDirection: "column",
          marginLeft: "12%",
        }}
      >
        <label>Archived</label>
        <Checkbox
          checked={archived}
          onChange={(event) => handleSelectArchived(event)}
        />
      </div>
      <Products
        open={open}
        setOpen={setOpen}
        currentId={currentId}
        setCurrentId={setCurrentId}
        products={products}
      />
    </div>
  );
};

export default ProductList;
